import * as THREE from 'three';
/*import { computeBoundsTree, disposeBoundsTree, acceleratedRaycast } from 'three-mesh-bvh';*/
import * as bvh from 'three-mesh-bvh'

THREE.BufferGeometry.prototype.computeBoundsTree = bvh.computeBoundsTree;
THREE.BufferGeometry.prototype.disposeBoundsTree = bvh.disposeBoundsTree;
THREE.Mesh.prototype.raycast = bvh.acceleratedRaycast;

export const threeMeshBvh = bvh;
export const BVH_READY = true;
